/**
 * Created by alex.y on 9/26/2017.
 */
export enum RequestType{
    Search = 0,
    ProductsAndTariffs = 1
}


// WEBPACK FOOTER //
// ./app/objects/products/requestType.ts